import { queryOptions, skipToken } from '@tanstack/react-query';

import { getPages } from '../api';

export const facebookQueries = {
  all: (pharmacyId: string | undefined) => ['facebook', pharmacyId] as const,
  pages: (pharmacyId: string | undefined) =>
    queryOptions({
      queryKey: [...facebookQueries.all(pharmacyId), 'pages'],
      queryFn: pharmacyId ? () => getPages(pharmacyId) : skipToken,
    }),
};
